import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpsertGdprConsentCategoriesMutationVariables = Types.Exact<{
  input: Types.UpsertGdprConsentCategoriesInput;
}>;


export type UpsertGdprConsentCategoriesMutation = { __typename?: 'Mutation', upsertGdprConsentCategories?: { __typename?: 'UpsertGdprConsentCategoriesPayload', user?: { __typename?: 'AuthenticatedUser', id: string } | { __typename?: 'IdentifiedUser', id: string } | null } | null };


export const UpsertGdprConsentCategories = /*#__PURE__*/ gql`
    mutation UpsertGdprConsentCategories($input: UpsertGdprConsentCategoriesInput!) {
  upsertGdprConsentCategories(input: $input) {
    user {
      id
    }
  }
}
    ` as unknown as DocumentNode<UpsertGdprConsentCategoriesMutation, UpsertGdprConsentCategoriesMutationVariables>;

          

          export const useUpsertGdprConsentCategoriesMutation = (options?:MutationHookOptions<UpsertGdprConsentCategoriesMutation, UpsertGdprConsentCategoriesMutationVariables>) => useMutation(UpsertGdprConsentCategories, options);
          

          export type UpsertGdprConsentCategoriesMutationOptions = MutationHookOptions<UpsertGdprConsentCategoriesMutation, UpsertGdprConsentCategoriesMutationVariables>;

          

          export type UpsertGdprConsentCategoriesMutationResult = ReturnType<typeof useUpsertGdprConsentCategoriesMutation>[1];

          
